<template>
    <div>
       <div class="mt-30 middle">
            <p>{{measObj.title}}</p>
            <p>
                <span>资料类别 : </span><span>{{cate}}</span>
            </p>
            <p>
                <span>资料价值 :</span><span> ￥{{measObj.fileprice}}</span>
            </p>
            <div class="middle_box">
               <span>资料文件 :</span>
               <a :href="measObj.fileresources" target="_blank">查看</a>
            </div>
            <p class="midle_desc" v-html="measObj.content"></p>
       </div>
    </div>
</template>
<script>
export default {
    props:{
      measObj:{
        type:Object
      }  
    },
    data(){
     return{
         cate:''
     }
    },
    methods:{
        getCate(id) {
            return this.$store.getters.itemIndutry(id);
        }
    },
    watch:{
       measObj(val){
         this.cate = this.getCate(val.category)
       } 
    }

}
</script>
<style scoped>
.middle{
    text-align: left;
}
.middle p:first-child{   
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.middle p:nth-child(2){   
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    margin-top: 20px;
}
.middle p:nth-child(2) span:nth-child(2){
    font-size: 12px;
}
.middle p:nth-child(3){   
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    margin-top: 10px;
}
.middle p:nth-child(3) span:nth-child(2){
    color: #FF7402;
}
.middle p:nth-child(4){   
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    margin-top: 10px;
}
.middle p:nth-child(4) span:nth-child(2){
    color: #3BAE30;
    font-size: 12px;
    margin-left: 10px;
}
.middle p:nth-child(5){
    margin-top: 20px;
    line-height: 24px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
.middle_foot{
    margin-top: 20px;
}
.middle_foot img{
    width: 215px;
    height: 161px;
    margin-right: 20px;
}
.middle_box a{
  font-size: 14px;
  color: #3BAE30 !important;
}
.middle_box span{
  font-size: 14px;
}
.midle_desc>>>p span{
  background-color: #fff !important;
}
.midle_desc >>>p img{
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/material.vue